import { createSelector } from 'reselect';

import { IRootState } from '../../../reducers';
import { mapCreationContestsResponse } from './mappers';

const creationContestsSelector = createSelector(
  [
    (state: IRootState) => state.studentEvents,
    (state: IRootState) => state.studentRewards,
    (state: IRootState) => state.sectionRef,
  ],
  (studentEvents, studentRewards, sectionRef) => {
    return mapCreationContestsResponse(studentEvents, studentRewards, sectionRef);
  },
);

export default creationContestsSelector;
